/**
 *
 * Storage
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import pick from 'lodash/pick';

class Storage extends React.PureComponent {
  constructor(props) {
    super(props);
    const { session, name } = props;
    this.sessionProps = session && session.split(',');
    let current;
    try {
      current = { ...JSON.parse(localStorage.getItem(name)), ...JSON.parse(sessionStorage.getItem(name)) };
    } catch (err) {
      // OK, could not read storage, use empty
    }
    this.state = current || {};
    this.clone = this.clone.bind(this);
  }

  hasUpdate = this.hasUpdate.bind(this);
  hasUpdate(data, selector) {
    const selected = selector(data, this.sessionProps);
    return (Object.keys(selected).length > 0);
  }

  updateStorage = this.updateStorage.bind(this)
  updateStorage(data, newState, storage, selector) {
    const { name } = this.props;
    if (this.hasUpdate(data, selector)) {
      const newStorage = selector(newState, this.sessionProps);
      storage.setItem(name, JSON.stringify(newStorage));
    }
  }

  handleUpdate = this.handleUpdate.bind(this);
  handleUpdate(data) {
    const { name } = this.props;
    this.setState((prevState) => {
      if (data === null) {
        sessionStorage.removeItem(name);
        localStorage.removeItem(name);
        return Object.keys(prevState).reduce((acc, key) => ({ ...acc, [key]: undefined }), {});
      }
      const newState = data === null ? {} : { ...prevState, ...data };
      this.updateStorage(data, newState, sessionStorage, pick);
      this.updateStorage(data, newState, localStorage, omit);
      return data;
    });
  }

  clone(elem) {
    const attribs = {
      storage: this.state,
      onUpdate: this.handleUpdate,
    };
    return React.cloneElement(elem, attribs);
  }

  render() {
    return React.Children.map(this.props.children, this.clone);
  }
}

Storage.propTypes = {
  name: PropTypes.string.isRequired,
  session: PropTypes.string,
  children: PropTypes.node,
};

Storage.defaultProps = {
  session: '',
};

export default Storage;



// WEBPACK FOOTER //
// ./src/components/Storage.js